import store from "store2";

class Util {
  private static storage = store.namespace('52KsvwKLkV2Zfs6Vj727');

  static isDebugLogs(): boolean {
    return Util.storage.has('log');
  }

  static isDebugClick(): boolean {
    return Util.storage.has('log.click');
  }
}

export default Util;
